module.exports = __webpack_public_path__ + "img/thumbs-down.bc59ef05.svg";